import CustomerDescription from './customerdescription';

class CustomerSearchOutput {
    constructor(json) {
        if (json != null) {
            if (json.duplicatesByName && json.duplicatesByName.length > 0) {
                this.duplicatesByName = json.duplicatesByName.map((c) => new CustomerDescription(c));
            } else {
                this.duplicatesByName = [];
            }
            if (json.duplicatesByBusinessId && json.duplicatesByBusinessId.length > 0) {
                this.duplicatesByBusinessId = json.duplicatesByBusinessId.map((c) => new CustomerDescription(c));
            } else {
                this.duplicatesByBusinessId = [];
            }
        }
    }
}

export default CustomerSearchOutput;
